import "./ButtonGroup.less";

export type ButtonGroupProps = {
    buttonGroupStart?: React.ReactNode;
    startCondition?: boolean;
    buttonGroupEnd?: React.ReactNode;
    endCondition?: boolean;
};

export function ButtonGroup({
    buttonGroupStart = <></>,
    startCondition = true,
    buttonGroupEnd = <></>,
    endCondition = true,
}: ButtonGroupProps) {
    return (
        <div className="ButtonGroup">
            {startCondition ? (
                <div className="button-group-start">{buttonGroupStart}</div>
            ) : (
                <></>
            )}
            {endCondition ? (
                <div className="button-group-end">{buttonGroupEnd}</div>
            ) : (
                <></>
            )}
        </div>
    );
}
